var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSpin8(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax_outline_calendar",
    "data-name": "vuesax/outline/calendar",
    transform: "translate(-492 -188)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "calendar",
    transform: "translate(492 188)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M.969,5.812A.976.976,0,0,1,0,4.844V.969A.976.976,0,0,1,.969,0a.976.976,0,0,1,.969.969V4.844A.976.976,0,0,1,.969,5.812Z",
    transform: "translate(9.365 1.615)",
    fill: "#0098da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M.969,5.812A.976.976,0,0,1,0,4.844V.969A.976.976,0,0,1,.969,0a.976.976,0,0,1,.969.969V4.844A.976.976,0,0,1,.969,5.812Z",
    transform: "translate(19.698 1.615)",
    fill: "#0098da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M1.292,2.576a1.286,1.286,0,0,1-.491-.1A1.333,1.333,0,0,1,.375,2.2,1.334,1.334,0,0,1,0,1.285,1.286,1.286,0,0,1,.1.794,1.491,1.491,0,0,1,.375.367,1.333,1.333,0,0,1,.8.1,1.319,1.319,0,0,1,2.209.367a1.358,1.358,0,0,1,.375.917,1.942,1.942,0,0,1-.026.258.821.821,0,0,1-.078.232.978.978,0,0,1-.116.232,2.035,2.035,0,0,1-.155.194A1.358,1.358,0,0,1,1.292,2.576Z",
    transform: "translate(9.687 16.153)",
    fill: "#0098da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M1.292,2.582a1.286,1.286,0,0,1-.491-.1,1.333,1.333,0,0,1-.426-.271A1.334,1.334,0,0,1,0,1.29,1.286,1.286,0,0,1,.1.8,1.491,1.491,0,0,1,.375.373,1.333,1.333,0,0,1,.8.1,1.3,1.3,0,0,1,2.209.373a1.358,1.358,0,0,1,.375.917,1.942,1.942,0,0,1-.026.258.821.821,0,0,1-.078.232.978.978,0,0,1-.116.232,2.035,2.035,0,0,1-.155.194A1.358,1.358,0,0,1,1.292,2.582Z",
    transform: "translate(14.208 16.147)",
    fill: "#0098da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-5",
    "data-name": "Vector",
    d: "M1.292,2.582a1.286,1.286,0,0,1-.491-.1,1.333,1.333,0,0,1-.426-.271L.22,2.014A.978.978,0,0,1,.1,1.781a.821.821,0,0,1-.078-.232A1.942,1.942,0,0,1,0,1.29,1.358,1.358,0,0,1,.375.373,1.333,1.333,0,0,1,.8.1,1.29,1.29,0,0,1,2.209.373a1.358,1.358,0,0,1,.375.917,1.942,1.942,0,0,1-.026.258.821.821,0,0,1-.078.232.978.978,0,0,1-.116.232,2.035,2.035,0,0,1-.155.194A1.358,1.358,0,0,1,1.292,2.582Z",
    transform: "translate(18.729 16.147)",
    fill: "#0098da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-6",
    "data-name": "Vector",
    d: "M1.292,2.567a1.286,1.286,0,0,1-.491-.1,1.492,1.492,0,0,1-.426-.271A1.358,1.358,0,0,1,0,1.276,1.286,1.286,0,0,1,.1.785,1.206,1.206,0,0,1,.375.358a1.352,1.352,0,0,1,1.834,0,1.358,1.358,0,0,1,.375.917,1.358,1.358,0,0,1-.375.917A1.358,1.358,0,0,1,1.292,2.567Z",
    transform: "translate(9.687 20.683)",
    fill: "#0098da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-7",
    "data-name": "Vector",
    d: "M1.292,2.567a1.358,1.358,0,0,1-.917-.375A1.358,1.358,0,0,1,0,1.276,1.286,1.286,0,0,1,.1.785,1.206,1.206,0,0,1,.375.358a1.352,1.352,0,0,1,1.834,0A1.206,1.206,0,0,1,2.48.785a1.286,1.286,0,0,1,.1.491,1.358,1.358,0,0,1-.375.917A1.358,1.358,0,0,1,1.292,2.567Z",
    transform: "translate(14.208 20.683)",
    fill: "#0098da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-8",
    "data-name": "Vector",
    d: "M1.292,2.584A1.358,1.358,0,0,1,.375,2.21,1.206,1.206,0,0,1,.1,1.784,1.286,1.286,0,0,1,0,1.293,1.286,1.286,0,0,1,.1.8,1.206,1.206,0,0,1,.375.376,1.29,1.29,0,0,1,1.537.027.779.779,0,0,1,1.783.1a.978.978,0,0,1,.233.116,2.035,2.035,0,0,1,.194.155,1.358,1.358,0,0,1,.375.917,1.358,1.358,0,0,1-.375.917A1.358,1.358,0,0,1,1.292,2.584Z",
    transform: "translate(18.729 20.666)",
    fill: "#0098da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-9",
    "data-name": "Vector",
    d: "M21.235,1.937H.9A.942.942,0,0,1,0,.969.942.942,0,0,1,.9,0H21.235a.942.942,0,0,1,.9.969A.942.942,0,0,1,21.235,1.937Z",
    transform: "translate(4.434 10.772)",
    fill: "#0098da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-10",
    "data-name": "Vector",
    d: "M17.76,25.833H7.427C2.712,25.833,0,23.121,0,18.406V7.427C0,2.712,2.712,0,7.427,0H17.76c4.715,0,7.427,2.712,7.427,7.427V18.406C25.187,23.121,22.475,25.833,17.76,25.833ZM7.427,1.937c-3.694,0-5.49,1.8-5.49,5.49V18.406c0,3.694,1.8,5.49,5.49,5.49H17.76c3.694,0,5.49-1.8,5.49-5.49V7.427c0-3.694-1.8-5.49-5.49-5.49Z",
    transform: "translate(2.906 3.552)",
    fill: "#0098da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-11",
    "data-name": "Vector",
    d: "M0,0H31V31H0Z",
    fill: "none",
    opacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpin8);
export default __webpack_public_path__ + "static/media/spin8.f6afd7b855c10cb83a7e3f7b0ce9588e.svg";
export { ForwardRef as ReactComponent };